import { Table, Button, Tooltip, Row, Col, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { DatePopupconfirm } from '../../../components/datePopupConfirm';
import dayjs from 'dayjs';

const TeamTable = ({ data, onEdit, markInactive, onAdd, loading  }) => {
  const columns = [
    { title: 'Team Member Name', dataIndex: 'name' },
    { title: 'Email', dataIndex: 'email' },
    { title: 'Phone', dataIndex: 'phone' },
    {
      title: 'Primary Contact',
      dataIndex: 'is_primary',
      render: (value) => value ? 'Yes' : 'No',
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      render: (value) => value ? 'Active' : 'Inactive'
    },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => (
        <Space gap="small" wrap>
          <Button onClick={() => onEdit(record)}>Edit</Button>
          <Tooltip placement='left' title={ !record.is_active ? `Deactivation Effective Date: ${dayjs(record.last_deactivation_date).format('MM/DD/YYYY')}` : '' }>
            <span>
              <DatePopupconfirm
                onConfirm={markInactive}
                customerId={null}
                record_id={record.id}
                is_active={record.is_active}
              />
            </span>
          </Tooltip>
        </Space>
      )
    }
  ];

  return (
    <>
      <Row justify="end">
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD TEAM MEMBER
          </Button>
        </Col>
      </Row>
      <Table 
        columns={columns}
        dataSource={data} 
        rowKey="id" 
        pagination={false} 
        loading={loading}
        scroll={{ x: 'max-content' }}
      />
    </>
  )
};

export default TeamTable;
